import React, { useEffect, useState } from 'react';
import { Button, Input, Modal, Form, Radio, Popconfirm } from 'antd';
import { openNotificationWithIcon } from '@frontend/src/utilities/notificationWithIcon';
import { filesCategoriesService } from '@frontend/src/core/services/files_categories_service';
import DragSortingTable from '../DragSortingTable';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './FileCategories.scss';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const CANDIDATES_CATEGORY_ID = 'documentos-firmados';
const POSTULATION_CATEGORY_ID = 'archivos-de-postulacion';
const FILES_MESSAGES = 'adjuntos-de-mensajes'

const FileCategories = ({ categories, organizationId }) => {
	const [showModal, setShowModal] = useState(false);
	const [categoryName, setCategoryName] = useState('');
	const [allowPublic, setAllowPublic] = useState(true);
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [isCreating, setIsCreating] = useState(null);
	const [categoriesList, setCategoriesList] = useState([]);
	const [isEditing, setIsEditing] = useState(null);
	const [isDeleting, setIsDeleting] = useState(null);
	const columnList = [
		{
			id: 1,
			title: 'Categoría',
			dataIndex: 'name',
			ellipsis: true,
		},
		{
			id: 2,
			title: 'Archivos',
			dataIndex: 'files_count',
			align: 'center',
			width: 90,
		},
		{
			id: 3,
			title: '',
			dataIndex: '',
			align: 'center',
			width: 90,
			fixed: 'right',
			render: row => categoryOptions(row),
		},
	];

	const sorter = (a, b) => {
		const cat1 = a.name.toUpperCase();
		const cat2 = b.name.toUpperCase();
		if (cat1 > cat2) {
			return 1;
		}
		if (cat1 < cat2) {
			return -1;
		}
		return 0;
	};

	const sorterNumber = (a, b) => {
		const cat1 = a.files_count;
		const cat2 = b.files_count;
		if (cat1 > cat2) {
			return 1;
		}
		if (cat1 < cat2) {
			return -1;
		}
		return 0;
	};

	const categoryOptions = category => {
		return (
			<div className="actions">
				{
					category.slug === CANDIDATES_CATEGORY_ID || category.slug === POSTULATION_CATEGORY_ID || category.slug === FILES_MESSAGES
						? (<>
								<span className='action-box' >
									<Button
										type="link"
										className="icon-item"
										size="small"
										onClick={() => onChangeState(category)}
									>
										<EditOutlined />
									</Button>
								</span>
								<span className='action-box'>
									<i className='fa fa-times' style={{color: "transparent"}}></i>
								</span>
							</>)
						: (
							<>
								<span className='action-box' >
									<Button
										type="link"
										className="icon-item"
										size="small"
										onClick={() => onChangeState(category)}
									>
										<EditOutlined />
									</Button>
								</span>
								<span className='action-box'>
									<Popconfirm
										title="¿Estás seguro de eliminar la categoría? (La categoría será eliminada de forma permanente)"
										onConfirm={() => destroyCategory(category)}
										onCancel={() => {}}
										okText="Eliminar"
										cancelText="Cancelar"
									>
										<Button type="link" className="icon-item" size="small">
											<DeleteOutlined />
										</Button>
									</Popconfirm>
								</span>
							</>)
				}
			</div>
		);
	};

	const showCategoryModal = () => {
		return (
			<Modal
				title={'Crear nueva categoría'}
				visible={showModal}
				onCancel={() => setShowModal(false)}
				onOk={() => (selectedCategory ? updateCategory() : createCategory())}
				cancelText={'Cancelar'}
				okText={'Guardar'}
			>
				<Form layout={'vertical'}>
					<Form.Item label={'Nombre de categoría'}>
						<Input
							onChange={e => setCategoryName(e.target.value)}
							value={
								selectedCategory && !categoryName
									? selectedCategory.name
									: categoryName
							}
						/>
					</Form.Item>
					<Form.Item label={'Privacidad'}>
						<Radio.Group
							defaultValue={
								selectedCategory ? selectedCategory.allow_public : true
							}
							onChange={e => setAllowPublic(e.target.value)}
						>
							<Radio.Button value={true}>Público</Radio.Button>
							<Radio.Button value={false}>Privado</Radio.Button>
						</Radio.Group>
					</Form.Item>
				</Form>
			</Modal>
		);
	};

	const onChangeState = category => {
		setSelectedCategory(category);
		setShowModal(true);
	};

	const createCategory = () => {
		filesCategoriesService.createNewFileCategory(
			{
				name: categoryName,
				allow_public: allowPublic,
				order: categoriesList[categoriesList.length - 1]?.order + 1 || 0,
				organization_id: organizationId,
			},
			success => {
				setIsCreating(success);
				openNotificationWithIcon(
					'success',
					'Categoria creada correctamente',
					''
				);
			},
			error => {
				console.error(error.response);
				openNotificationWithIcon(
					'error',
					'Error al crear la categoría: Ya existe una categoría con este identificador',
					''
				);
			}
		);
	};

	const destroyCategory = row => {
		filesCategoriesService.deleteFileCategory(
			row.id,
			success => {
				setIsDeleting(success);
				openNotificationWithIcon(
					'success',
					'Categoria borrada correctamente',
					''
				);
			},
			error => console.error(error)
		);
	};

	const updateCategory = () => {
		filesCategoriesService.editFileCategory(
			{
				id: selectedCategory.id,
				name: categoryName,
				allow_public: allowPublic,
				organization_id: organizationId,
			},
			success => {
				setIsEditing(success);
				openNotificationWithIcon(
					'success',
					'Categoria actualizada correctamente',
					''
				);
			},
			error => console.error(error)
		);
	};

	const updateOrder = (data, id) => {
		filesCategoriesService.editFileCategory(
			{
				id: id,
				order: data.order,
			},
			success => {
				return success;
			},
			error => console.error(error)
		);
	};

	const bringCategories = () => { filesCategoriesService.allFilesCategories(
			success => setCategoriesList(showOnlyFilteredCategories(success)),
			error => console.error(error)
		);
	};

	const showOnlyFilteredCategories = (categories) => {
		return categories.filter((x) => x.name != CANDIDATES_CATEGORY_ID || x.files_count > 0)
	}

	useEffect(() => {
		if (showModal && selectedCategory) {
			setCategoryName(selectedCategory.name);
			setAllowPublic(selectedCategory.allow_public);
		} else {
			setCategoryName('');
			setAllowPublic(true);
		}
	}, [showModal]);

	useEffect(() => {
		if (isCreating) {
			bringCategories();
			setIsCreating(null);
			setShowModal(false);
		}
	}, [isCreating]);

	useEffect(() => {
		if (isDeleting) {
			bringCategories();
			setIsDeleting(null);
		}
	}, [isDeleting]);

	useEffect(() => {
		if (isEditing) {
			bringCategories();
			setShowModal(false);
			setIsEditing(null);
		}
	}, [isEditing]);

	useEffect(() => {
		bringCategories();
	}, []);

	return (
		<DndProvider backend={HTML5Backend}>
			<div>
				<div className={'card settings-card'}>
					<div className='card-header'>
						<div className='title'>Categoría de archivos</div>
					</div>
					<div className='card-body'>
						<div>
							<DragSortingTable
								columnList={columnList}
								dataList={categoriesList}
								setDataList={setCategoriesList}
								updateFunction={updateOrder}
							/>
						</div>
						<div className='button-add'>
							<Button onClick={() => onChangeState(null)}>
								Crear nueva categoría
							</Button>
						</div>
					</div>
				</div>
				{showModal && showCategoryModal()}
			</div>
		</DndProvider>
	);
};

export default FileCategories;
